module.exports = __webpack_public_path__ + "img/teasers_5.751d4558.jpg";